// Configuration for API endpoints so every build hits the backend instead of CRA’s static server.
const localDevApi = 'http://localhost:8083';
const hostname = window.location.hostname;
const isLocalHost = ['localhost', '127.0.0.1', '::1'].includes(hostname);

let apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl) {
  apiUrl = (process.env.NODE_ENV === 'development' || isLocalHost) ? localDevApi : `https://${window.location.host}`;
}

// Force HTTPS when the app is not being served from localhost (or dev mode) to avoid Mixed Content blocks.
if (!isLocalHost && apiUrl.startsWith('http://')) {
  apiUrl = apiUrl.replace('http://', 'https://');
}

export const API_BASE_URL = apiUrl;
